import React, { useState } from 'react';
import './App.css';
import CommissionCalculator from './components/CommissionCalculator';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        {/* Header content removed */}
      </header>
      <main>
        <CommissionCalculator />
      </main>
      <footer className="App-footer">
        <h2>Ingwenya Empire</h2>
      </footer>
    </div>
  );
}

export default App;
